import * as React from 'react';
import {
    AppBar,
    Toolbar,
    Typography,
    Box,
    Button,
    TextField,
    Grid,
    FormGroup,
    FormControlLabel,
    Checkbox,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const setBodyOverflow = (value) => {
    document.body.style.overflow = value;
};
const handleNavigation = (path) => () => {
    window.location.href = `http://localhost:8000/client${path}`;
};

function Header() {
    return (
        <AppBar
            position="static"
            color="transparent"
            elevation={0}
            sx={{ padding: "0 20px" }}
        >
            <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                    DAYBOOK E-POS
                </Typography>
                <Box sx={{ display: "flex", gap: "20px" }}>
                    <Button color="inherit" onClick={handleNavigation("/register")}>
                        Register
                    </Button>
                    <Button color="inherit" onClick={handleNavigation("/login")}>
                        Login
                    </Button>
                </Box>
            </Toolbar>
        </AppBar>
    );
}

function HeroSection() {
    React.useEffect(() => {
        setBodyOverflow("visible");
        return () => {
            setBodyOverflow("hidden");
        };
    }, []);
    return (
        <Box
            sx={{
                position: "relative",
                width: "100vw",
                aspectRatio: "16/9",
                overflow: "hidden",
            }}
        >
            <Box
                component="iframe"
                src="https://player.vimeo.com/video/906692511?badge=0&autopause=0&player_id=0&app_id=58479&background=1&autoplay=1"
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    border: 0,
                }}
                allow="autoplay; fullscreen"
                allowFullScreen
            />
        </Box>
    );
}

function MainSection() {
    return (
        <>
            <Box sx={{ position: "relative", padding: "40px" }}>
                <Typography variant="h2" gutterBottom sx={{ color: "#D4D4D4" }}>
                    The Edinburgh Festival Fringe is one of the greatest celebrations of
                    arts and culture in the world. Every August, the city welcomes an
                    explosion of creative energy, bringing thousands of artists and
                    performers to its streets and legendary venues. We are proud to be the
                    Fringe’s official street advertising provider.
                </Typography>
            </Box>
            <Box sx={{ borderTop: '1px solid black', borderBottom: '1px solid black', display: 'flex', justifyContent: 'start', marginTop: '20px',  marginBottom: '30px' }}>
                <Button variant="contained" color="primary" sx={{ borderRadius: 0 }} onClick={handleNavigation("/login")}>
                    Shop All Products
                </Button>
            </Box>
        </>
    );
}

function Footer() {
    return (
        <Box sx={{ backgroundColor: "#333", color: "#fff", padding: "40px 20px" }}>
            <Grid container>
                <Grid item xs={12} md={5}>
                    <Typography variant="h6" gutterBottom>
                        Newsletter
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                        Join our mailing list for the latest news and features
                    </Typography>
                    <TextField
                        variant="standard"
                        placeholder="Your email address"
                    />
                    <FormGroup row>
                        <FormControlLabel
                            control={<Checkbox name="music" />}
                            label="Music"
                        />
                        <FormControlLabel
                            control={<Checkbox name="brands" />}
                            label="Brands"
                        />
                        <FormControlLabel control={<Checkbox name="art" />} label="Art" />
                    </FormGroup>
                    <FormControlLabel
                        control={<Checkbox name="accept" />}
                        label="I accept the privacy & cookies policy and terms & conditions."
                        sx={{ color: "#aaa" }}
                    />
                    <Button variant="contained" color="primary" fullWidth>
                        Join
                    </Button>
                </Grid>
                <Grid item xs={12} md={2}>
                    <Typography variant="h6" gutterBottom>
                        Agency
                    </Typography>
                    <Typography variant="body2">Terms & Conditions</Typography>
                    <Typography variant="body2">Privacy Policy</Typography>
                    <Typography variant="body2">Cookies Policy</Typography>
                </Grid>
                <Grid item xs={12} md={2}>
                    <Typography variant="h6" gutterBottom>
                        Social
                    </Typography>
                    <Typography variant="body2">Instagram</Typography>
                    <Typography variant="body2">Twitter</Typography>
                    <Typography variant="body2">LinkedIn</Typography>
                </Grid>
                <Grid item xs={12} md={3}>
                    <Typography variant="h6" gutterBottom>
                        Contact
                    </Typography>
                    <Typography variant="body2">HEAD OFFICE</Typography>
                    <Typography variant="body2">
                        15 Duncan Terrace, London, N1 8BZ, United Kingdom
                    </Typography>
                    <Typography variant="body2">+44 (0) 20 7916 5483</Typography>
                    <Typography variant="body2">JACK ARTS</Typography>
                    <Typography variant="body2">scotland@jack-arts.co.uk</Typography>
                </Grid>
            </Grid>
            <Box sx={{ textAlign: "center", marginTop: "20px", color: "#aaa" }}>
                <Typography variant="body2">
                    &copy;BUILDHOLLYWOOD All rights reserved
                </Typography>
            </Box>
        </Box>
    );
}

export default function ClientLandingPage() {
    return (
        <>
            <Header />
            <HeroSection />
            <MainSection />
            <Footer />
        </>
    );
}
